import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import { adminFetch } from '../../../utils/api';

export default function NewPasarelaPagos() {
    const [mensaje, setMensaje] = useState('');
    const [storeId, setStoreId] = useState('1');
    const [gatewayName, setGatewayName] = useState('');
    const [gatewayType, setGatewayType] = useState('');
    const [publicKey, setPublicKey] = useState('');
    const [secretKey, setSecretKey] = useState('');
    const [merchantId, setMerchantId] = useState('');
    const [webhookUrl, setWebhookUrl] = useState('');
    const [environment, setEnvironment] = useState('sandbox');
    const [priority, setPriority] = useState('');
    const [configJson, setConfigJson] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
        setStoreId('1');
        setGatewayName('');
        setGatewayType('');
        setPublicKey('');
        setSecretKey('');
        setMerchantId('');
        setWebhookUrl('');
        setEnvironment('sandbox');
        setPriority('');
        setConfigJson('');
        setModalOpen(!modalOpen);
    };

    const crear = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('storeId', storeId);
        formData.append('gatewayName', gatewayName);
        formData.append('gatewayType', gatewayType);
        formData.append('publicKey', publicKey);
        formData.append('secretKey', secretKey);
        formData.append('merchantId', merchantId);
        formData.append('webhookUrl', webhookUrl);
        formData.append('environment', environment);
        formData.append('priority', priority);
        formData.append('configJson', configJson);

        setMensaje('Procesando...');

        try {
            const response = await adminFetch(`${baseURL}/api/admin/pasarelas`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                toggleModal();
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            
            {/* Botón para abrir el modal */}
            <button onClick={toggleModal} className='btnSave'>
                Agregar Pasarela de Pagos
            </button>
            
            {modalOpen && (
                <div className='modal'>
                    <div className='modal-content'>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Pasarela de Pagos</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form className='flexGrap' onSubmit={(e) => crear(e)}>
                            <fieldset>
                                <legend>Nombre Pasarela</legend>
                                <input
                                    type='text'
                                    name='gatewayName'
                                    value={gatewayName}
                                    onChange={(e) => setGatewayName(e.target.value)}
                                    required
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Tipo</legend>
                                <input
                                    type='text'
                                    name='gatewayType'
                                    value={gatewayType}
                                    onChange={(e) => setGatewayType(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Clave Publica</legend>
                                <input
                                    type='text'
                                    name='publicKey'
                                    value={publicKey}
                                    onChange={(e) => setPublicKey(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Clave Secreta</legend>
                                <input
                                    type='text'
                                    name='secretKey'
                                    value={secretKey}
                                    onChange={(e) => setSecretKey(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Id Comerciante</legend>
                                <input
                                    type='text'
                                    name='merchantId'
                                    value={merchantId}
                                    onChange={(e) => setMerchantId(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                <legend>Webhook Url</legend>
                                <input
                                    type='text'
                                    name='webhookUrl'
                                    value={webhookUrl}
                                    onChange={(e) => setWebhookUrl(e.target.value)}
                                />
                            </fieldset>
                            <fieldset>
                                    <legend>Ambiente</legend>
                                    <select
                                        value={environment}
                                        onChange={(e) => setEnvironment(e.target.value)}
                                        disabled
                                    >
                                        <option value="sandbox">Pruebas</option>
                                        <option value="production">Producción</option>
                                    </select>
                                </fieldset>
                            <fieldset>
                                <legend>Prioridad</legend>
                                <input
                                    type='number'
                                    name='priority'
                                    value={priority}
                                    onChange={(e) => setPriority(e.target.value)}
                                />
                            </fieldset>

                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type='submit' /* onClick={(e) =>crear(e)}  */className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
